import {SagaIterator} from "redux-saga";
import {call, takeEvery} from "redux-saga/effects";
import {WithPayload} from "types/basic";
import {UUID} from "@pinch-financial/pinch-ui-components";
import {getLowestRate} from "./SaaSWelcomePage.action";
import {fetchLowestRateOperation} from "~/store/operation/whitelabel";

export function* lowestRate({
  payload,
}: WithPayload<UUID>): SagaIterator {
  yield call(fetchLowestRateOperation.saga, payload);
}

export default function* saasWelcomePageSaga(): SagaIterator {
  yield takeEvery(getLowestRate, lowestRate);
}
